import React, { Component, Fragment } from 'react'
import VehicleDetails from '.';

import CardPrivate from '../CardSeller/CardPrivate';
import CardDealership from '../CardSeller/CardDealership';
import ParceiroSantanderStamp from '@/modern/components/Stamps/ParceiroSantander'
import SellerBadgeModal from '@/modern/components/SellerBadgeModal'
import ModalContainer from '@/modern/components/ModalContainer'

import './VehicleDetails.scss';

class VehicleDetailsSellerInformation extends Component {
    constructor(props) {
        super(props);
        this.renderSellerInformation = this.renderSellerInformation.bind(this)
        this.renderCard = this.renderCard.bind(this)
        this.state = {
            showBadgeModal:false
        }
    }
    seePhone() {
        this.props.seePhone('verTelefone')
    }
    renderCard() {
        if (this.props.seller) {
            if (this.props.seller.SellerType == 'PJ')
                return <CardDealership ad={this.props.ad} data={this.props.seller} phonesDetail={this.props.phonesDetail} seePhone={this.seePhone.bind(this)}
                    showButtonPhone={this.props.showButtonPhone} dealerSchedule={this.props.dealerSchedule} loading={this.props.loading} vehicleType={this.props.vehicleType} />
            else if (this.props.seller.SellerType == 'PF')
                return <CardPrivate data={this.props.seller} phonesDetail={this.props.phonesDetail} seePhone={this.seePhone.bind(this)}
                    showButtonPhone={this.props.showButtonPhone} loading={this.props.loading} vehicleType={this.props.vehicleType} />
        }
    }
    renderSellerBadge(){
        return (
            <Fragment>
                <ModalContainer show={this.state.showBadgeModal} useClose={true} useWhiteBox={true} onBgClick={ this.toggleSellerBadgeModal.bind(this) }>
                    <SellerBadgeModal />
                </ModalContainer>
                <div className="VehicleDetails__SellerBadge" onClick={ this.toggleSellerBadgeModal.bind(this) }>
                    <ParceiroSantanderStamp />
                </div>
            </Fragment>
        )
    }
    toggleSellerBadgeModal(){
        this.setState({ showBadgeModal : !this.state.showBadgeModal })
    }
    renderSellerInformation() {
        return (
            <Fragment>
                {this.props.sellerBadge && this.renderSellerBadge()}
                <div className="VehicleDetails__container__header">
                    <h2 className="VehicleDetails__container__header__title">Sobre o vendedor</h2>
                </div>
                {this.renderCard()}
            </Fragment>
        )
    }
    render() {
        return (
            this.props.seller ?
                <VehicleDetails className={this.props.className ? this.props.className : ''} id={this.props.id ? this.props.id : ''} title={this.props.title ? this.props.title : ''}>
                    {this.renderSellerInformation()}
                </VehicleDetails>
                : null
        )
    }
}

export default VehicleDetailsSellerInformation